export * from './product-portal-web-repository';